import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef, AfterContentInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LaunchDialogService, FormErrorsComponent } from "@spartacus/storefront";
import { Subscription } from "rxjs";
import { KnBrMessageDialogService } from "src/app/common/kn-br-message-dialog/kn-br-message-dialog.service";
import { KnBrCommonService } from "src/app/services/kn-br-common.service";
import { SiteAdapter } from "@spartacus/core";
import { NgClass, AsyncPipe } from "@angular/common";
import { NgSelectComponent } from "@ng-select/ng-select";
import { CwtSpinnerComponent } from "../../common/cwt-spinner/cwt-spinner.component";
@Component({
    selector: "knbr-kn-br-contact",
    templateUrl: "./kn-br-contact.component.html",
    styleUrls: ["./kn-br-contact.component.scss"],
    imports: [
        ReactiveFormsModule,
        NgClass,
        FormErrorsComponent,
        NgSelectComponent,
        CwtSpinnerComponent,
        AsyncPipe,
    ],
})
export class KnBrContactComponent implements OnInit, AfterContentInit, OnDestroy {
  allSubscriptions = new Subscription();
  contactForm: FormGroup;
  showForm = true;
  successContent = false;
  userExistsContent = false;
  showSuccessOrFailureContent = false;
  // hbspt: any;
  entityOptions = [
    { label: "Corporation", value: "corporation" },
    { label: "Partnership", value: "partnership" },
    { label: "LLC", value: "llc" },
    { label: "Sole Proprietorship", value: "sole_proprietorship" },
  ];
   stateData: any[];

  successTitle = "Thank you for registering!";
  successContent1 = 'Your user name and password will be sent to your email shortly!'; 
  successContent2 = `If you don't see the email within the next few minutes, please check your junk folder.`;
  failureTitle = 'Account Already Exists';
  failureContent = 'An account with this email already exists. Please sign in or reset your password if needed.';

  constructor(
    protected knBrMessageDialogService: KnBrMessageDialogService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    private formBuilder: FormBuilder,
    protected activatedRoute: ActivatedRoute,
    protected knBrCommonService: KnBrCommonService,
    private router: Router,
    protected cdr: ChangeDetectorRef,
     private siteAdapter: SiteAdapter,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadStates();
  }

  initForm() {
    this.contactForm = this.formBuilder.group({
      firstName: ["", [Validators.required, Validators.maxLength(50)]],
      lastName: ["", [Validators.required, Validators.maxLength(50)]],
      companyName: ["", [Validators.required, Validators.maxLength(100)]],
      email: ["", [Validators.required, Validators.maxLength(254)]],
      mobilePhone: ["", [Validators.required, Validators.maxLength(20)]],
      faxNumber: [""],
      otherNumber: [""],
      addressLine1: ["", [Validators.required, Validators.maxLength(30)]],
      addressLine2: ["", [Validators.maxLength(30)]],
      city: ["", [Validators.required, Validators.maxLength(85)]],
      state: [null, [Validators.required]],
      zipcode: ["", [Validators.required, Validators.maxLength(10)]],
      url: [""],
      entityType: ["", Validators.required],
      federalTaxId: [""],
      contractorLicense: ["", [Validators.required, Validators.maxLength(50)]],
      dateBegan: [""],
      dateCurrentManagement: [""],
    });
  }

  loadStates(): void {
    const regionSub = this.siteAdapter.loadRegions('US').subscribe((res) => {
      if (res) {
        this.stateData = res.filter((eachItem: any) =>
          eachItem.isocode.startsWith('US')
        );
        this.cdr.detectChanges();
      }
    });
    this.allSubscriptions.add(regionSub);
  }

  submitForm() {
    if (this.contactForm.valid) {
      this.knBrCommonService.setInlineSpinner('registration-loader');
      this.knBrCommonService.submitAccountRegistration(this.contactForm.value).subscribe((res: any) => {
        this.showForm = false;
        this.knBrCommonService.setInlineSpinner('');
        this.showSuccessOrFailureContent = true;
        if (res?.status === 'AWAIT' && !res?.isError) {
          this.successContent = true;
          this.userExistsContent = false;
          this.cdr.detectChanges();
        } else if (res?.status === 'EXISTS' && !res?.isError) {
          this.successContent = false;
          this.userExistsContent = true;
          this.cdr.detectChanges();
        }
      })
    } else {
      this.contactForm.markAllAsTouched();
    }
  }

  navigateTo() {
    this.router.navigateByUrl('/');
  }

  ngAfterContentInit() {
    // if ((window as any).hbspt && (window as any).hbspt.forms) {
    //     (window as any).hbspt.forms.create({
    //       portalId: "118964",
    //       formId: "728b2682-d161-4c73-bff6-1717b2242854",
    //       region: "na1",
    //       target: "#hubspotForm"
    //     });
    //   }
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
  }
}
